import { c as _c } from "react/compiler-runtime";
import Star from "@catchy/assets/svgs/star.svg";
import IconButton from "./IconButton";
export default function FavouriteButton(t0) {
  const $ = _c(27);
  const {
    stopId,
    favourites,
    setFavourites,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "icon" : t1;
  let t2;
  if ($[0] !== favourites || $[1] !== stopId) {
    t2 = Array.isArray(favourites) && favourites.includes(stopId);
    $[0] = favourites;
    $[1] = stopId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isFavourited = t2;
  let t3;
  if ($[3] !== setFavourites) {
    t3 = value => setFavourites(t4 => {
      const current = t4 === undefined ? [] : t4;
      const list = Array.isArray(current) ? current : [];
      return list.includes(value) ? list.filter(item => item !== value) : [...list, value];
    });
    $[3] = setFavourites;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const toggleFavourite = t3;
  if (variant === "pill") {
    let t4;
    if ($[5] !== stopId || $[6] !== toggleFavourite) {
      t4 = () => toggleFavourite(stopId);
      $[5] = stopId;
      $[6] = toggleFavourite;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    const t5 = `inline-flex flex-1 flex-shrink-0 items-center justify-center gap-1 rounded-full py-2 pl-2.5 pr-4 text-center text-sm font-semibold leading-tight outline-none ring-1 transition-colors motion-reduce:transition-none focus-visible:ring ${isFavourited ? "bg-orange-50 text-orange-600 ring-orange-300/80 hover:bg-orange-100 focus-visible:ring-orange-300/80 dark:bg-orange-500/10 dark:text-orange-300 dark:ring-orange-300/40 dark:hover:bg-orange-500/20" : "bg-white text-blue-500 ring-blue-500/50 hover:bg-zinc-100 focus-visible:ring-blue-500/50 dark:bg-black dark:text-blue-300 dark:ring-blue-300 dark:hover:bg-zinc-800"}`;
    const t6 = isFavourited ? "Remove from favourites." : "Add to favourites";
    const t7 = `h-4 w-4 transition-colors duration-300 motion-reduce:transition-none ${isFavourited ? "text-orange-400" : "text-zinc-400/60"}`;
    let t8;
    if ($[8] !== t7) {
      t8 = <Star className={t7} />;
      $[8] = t7;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    const t9 = isFavourited ? "Favourited" : "Favourite";
    let t10;
    if ($[10] !== isFavourited || $[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t8 || $[15] !== t9) {
      t10 = <button type="button" aria-pressed={isFavourited} onClick={t4} className={t5} title={t6}>{t8}{t9}</button>;
      $[10] = isFavourited;
      $[11] = t4;
      $[12] = t5;
      $[13] = t6;
      $[14] = t8;
      $[15] = t9;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    return t10;
  }
  const t4 = isFavourited ? "Remove from favourites" : "Add to favourites";
  let t5;
  if ($[17] !== stopId || $[18] !== toggleFavourite) {
    t5 = () => toggleFavourite(stopId);
    $[17] = stopId;
    $[18] = toggleFavourite;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const t6 = `${isFavourited ? "text-orange-400" : "text-zinc-400/60"} h-6 w-6 transition-colors duration-300 motion-reduce:transition-none`;
  let t7;
  if ($[20] !== t6) {
    t7 = <Star className={t6} aria-hidden="true" />;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== isFavourited || $[23] !== t4 || $[24] !== t5 || $[25] !== t7) {
    t8 = <IconButton label={t4} aria-pressed={isFavourited} onClick={t5}>{t7}</IconButton>;
    $[22] = isFavourited;
    $[23] = t4;
    $[24] = t5;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}